import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDataService } from '../efaact.data-service';
import { JobTimerModel } from './job-timer.model';

export const entityName = 'JobTimer';
@Injectable({ providedIn: 'root' })
export class JobTimerDataService extends EfaactDataService<JobTimerModel> {
    mapItems(item: JobTimerModel): JobTimerModel {
        return {
            ...item,
            id: item.Jobdesc
        };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
